export default __webpack_public_path__ + "static/media/icons8-renew.8518a8a9.svg";